import { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import Form from "../../interface/Form";
import FormRow from "../../interface/FormRow";
import Input from "../../interface/Input";
import Button from "../../interface/Button";
import { useSearchParams } from "react-router-dom";
import { useUpdateExtended } from "./useUpdateExtended";
import { useGetExtended } from "./useGetExtended";
import { UserContext } from "../../contexts/UserContext";
import { QueryClient, useQueryClient } from "@tanstack/react-query";

function InfoExtended() {
  const { userDetails } = useContext(UserContext);
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();
  const [searchParams] = useSearchParams();

  const employeeId = searchParams.get("id");
  const { mutate: updateExtended } = useUpdateExtended();
  const { data, isLoading, isError, error } = useGetExtended(employeeId);
  // React Query's useQuery automatically refetches when employeeId changes
  useEffect(() => {
    // Clear form when starting a new query or when an error occurs
    if (isLoading || isError) {
      reset(); // Resets to initial form state or you can pass specific values to reset to
    }
  }, [employeeId, isLoading, isError, reset]);

  useEffect(() => {
    // Check if data is loaded and valid inside the useEffect
    if (data && data.data && data.data.infoExtended && !isLoading) {
      const deserializedInfo = JSON.parse(data.data.infoExtended);
      Object.keys(deserializedInfo).forEach((key) => {
        setValue(key, deserializedInfo[key], { shouldValidate: true });
      });
    }
  }, [data, isLoading, setValue]); // Include data and isLoading in the dependency array

  const onSubmit = (data) => {
    // Ensure employeeId is not null or undefined
    if (!employeeId) {
      console.error("Employee ID is missing.");
      return;
    }
    const userData = {
      id: employeeId,
      infoExtended: JSON.stringify(data),
    };
    updateExtended(userData);
    console.log("Submitted: ", userData);
    // Submit or process the data as needed
  };

  return (
    <Form type="modal" onSubmit={handleSubmit(onSubmit)}>
      <FormRow label="Home Address">
        <Input type="text" {...register("homeAddress", { required: true })} />
      </FormRow>
      <FormRow label="Home PostCode">
        <Input type="text" {...register("homePostCode", { required: true })} />
      </FormRow>
      <FormRow label="Home PostCity">
        <Input type="text" {...register("homeCity", { required: true })} />
      </FormRow>
      <FormRow label="Phone Number">
        <Input type="tel" {...register("phoneNumber", { required: true })} />
      </FormRow>

      <FormRow label="Emergency Contact Name">
        <Input type="text" {...register("emergencyContactName")} />
      </FormRow>
      <FormRow label="Emergency Contact Phone">
        <Input type="tel" {...register("emergencyContactPhone")} />
      </FormRow>

      <Button type="submit">Update Info</Button>
    </Form>
  );
}

export default InfoExtended;
